
import { Component, Vue, Watch } from "vue-property-decorator";
import { readUserProfile } from "@/store/main/getters";
import {shortenText} from "@/utils";
import { ref } from 'vue';
@Component({
  methods: {shortenText},
  components: {

  },
})

export default class Wiki extends Vue {
/** old url https://wiki.dfclub.ai/?cmd=hideLogo 
 * new 
 */
  /**
     *
OLD_USER, NEW_USER, CLIENT, RESIDENT.
Изначально все текущие пользователи станут OLD_USER,
новые регистрации - NEW_USER,
после прохождения подтверждения все становятся RESIDENT.
     */

  public wikiFrame = ref(null)

  get userProfile() {
    return readUserProfile(this.$store);
  }

  /** не безопасный вариант
   * <iframe ref="wikiFrame"
            :src="iframeSrc"
            class="wiki-iframe"></iframe>
  
  get iframeSrc() {

   
    const params = new URLSearchParams({
      cmd: 'hideLogo',
      role: this.userProfile?.role || ''
    });
    return `https://wiki.dfclub.ai/role.php?${params.toString()}`;
  }
     // example https://wiki.dfclub.ai/role.php?cmd=hideLogo&role=RESIDENT 
   */

  public handleLoad() {
    // Получаем DOM-элемент через this.$refs
    const iframe = this.$refs.wikiFrame as HTMLIFrameElement;
    if (!iframe || !iframe.contentWindow) return;
    
setTimeout(() => {
    const message = {
      cmd: "hideLogo",
      role: this.userProfile?.role ?? 'NOROLE',
      path: this.$route.path,
    };
  //  console.log('postMessage https://wiki.dfclub.ai', message);
   iframe.contentWindow!.postMessage(message, "https://wiki.dfclub.ai");
    }, 100);
  }
   
@Watch('$route.path') 
  onRouteChange(newPath: string) {
  const iframe = this.$refs.wikiFrame as HTMLIFrameElement;
  if (!iframe || !iframe.contentWindow) return;

  iframe.contentWindow.postMessage({
    cmd: "navigate",
    path: newPath,
    role: this.userProfile?.role ?? 'NOROLE'
  }, "https://wiki.dfclub.ai");
}

}
